export const PRIORITY_LOW = 'low';
export const PRIORITY_NORMAL = 'normal';
export const PRIORITY_HIGH = 'high';
export const PRIORITY_URGENT = 'urgent';

export const PRIORITIES = [
  PRIORITY_LOW,
  PRIORITY_NORMAL,
  PRIORITY_HIGH,
  PRIORITY_URGENT
];
